import _ from 'lodash';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import * as Connection from './../libs/connections';

import Preloader from './../components/global/Preloader';
import HeroBanner from './../components/HeroBanner';
import OurCarAvatars from '../components/OurCarAvatars';
import OurPartners from '../components/OurPartners';
import RentIn6Steps from '../components/RentIn6Steps';
import SectionImageText from '../components/SectionImageText';
import SectionContact from '../components/SectionContact';

import '../styles/sites/Home.css';
import '../styles/sites/HomePage.css';

import heroVideo from '../assets/video/hero-home-video.mp4';
import mouse from '../assets/icons-main/mouse.png';
import styled from 'styled-components';
import { HomeHeroBannerIcons } from '../components/HomeHeroBannerIcons';

import withoutpayIcon from '../assets/icons-fleet/icon-shorttime-withoutpay.svg';
import wheelIcon from '../assets/icons-fleet/icon-fleet-wheel.svg';
import garageIcon from '../assets/icons-fleet/icon-shorttime-garage.svg';

const HomeBannerText = styled.div`
    position: absolute;
    top: 250px;
    left: 50%;
    transform: translate(-50%, 0);
    max-width: 1550px;
    margin: 0 auto;
    width: 100%;
    padding: 0 30px;

    h2 {
        color: #9ca0a1;
        font-family: 'marsextended-regular';
        font-size: 40px;
        margin-bottom: 70px;
        max-width: 870px;
        text-transform: none;
    }
    h3 {
        color: #ff5000;
        font-family: 'marsextended-regular';
        font-size: 40px;
        max-width: 870px;
        text-transform: none;
    }

    @media (max-width: 767.98px) {
        top: 130px;

        h2 {
            font-size: 28px;
        }
        h3 {
            font-size: 28px;
        }
    }
`;

export default class Home extends Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            error: false,
            sliderHomeElements: [],
            sliderHomeLeftImage: '',
            textPhotoValue: '',
            textPhotoImage: ''
        };
    }

    componentDidMount() {
        (async () => {
            try {
                const response = await Connection.getPageBySlug(
                    'strona-glowna'
                );
                this.setState({
                    loading: false,
                    response,
                    sliderHomeElements: response.acf.SliderHomeElements,
                    sliderHomeLeftImage: response.acf.SliderHomeLeftImage,
                    textPhotoValue: response.acf['section-text-photo-value'],
                    textPhotoImage:
                        response.acf['section-text-photo-url']['url']
                });
            } catch (err) {
                this.setState({
                    error: true
                });
            }
        })().catch(err => {
            console.error(err);
        });
    }

    render() {
        const photos = [withoutpayIcon, wheelIcon, garageIcon];

        if (!this.state.error) {
            return (
                <div className="page-home scroll">
                    <Preloader global loading={this.state.loading} />
                    <img className="mouse" src={mouse} alt="" />
                    <HeroBanner
                        fulljustify
                        video
                        backgroundImage={heroVideo}
                        headerText="All ready to ride"
                    />
                    <HomeBannerText>
                        <div className="container container-small">
                            <div className="row">
                                <div className="col-12">
                                    <h2>
                                        {_.get(
                                            this.state,
                                            'response.acf.heroBanner.title',
                                            ''
                                        )}
                                    </h2>
                                    <h3>
                                        {_.get(
                                            this.state,
                                            'response.acf.heroBanner.subtitle',
                                            ''
                                        )}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </HomeBannerText>
                    <HomeHeroBannerIcons>
                        <ul className="">
                            {_.get(
                                this.state,
                                'response.acf.sliderHome',
                                []
                            ).map((sliderElem, idx) => (
                                <li className="long" key={idx}>
                                    <span className="sell-item">
                                        <img
                                            src={photos[idx]}
                                            alt="Icon"
                                            className="icon-offer"
                                        />
                                        <h5>{sliderElem.sliderHomeTitle}</h5>
                                        <p>{sliderElem.sliderHomeSubTitle}</p>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </HomeHeroBannerIcons>
                    <OurCarAvatars
                        paddingTop={400}
                        sectionNumber={'01.'}
                        text={'Nasze pojazdy'}
                    />
                    <RentIn6Steps
                        paddingTop={130}
                        sectionNumber={'02.'}
                        // text={"Wynajem v1rage </br>w 6 szybkich krokach"}
                        text={_.get(
                            this.state,
                            'response.acf.rent6steps.title',
                            ''
                        )}
                        elements={_.get(
                            this.state,
                            'response.acf.rent6steps.steps',
                            []
                        )}
                    />
                    {this.state.textPhotoValue !== '' && (
                        <SectionImageText
                            text={this.state.textPhotoValue}
                            wrapperClasses={`container container-small`}
                            backgroundImage={this.state.textPhotoImage}
                            paddingTop={150}
                            paddingBottom={200}
                        />
                    )}
                    <OurPartners
                        paddingTop={0}
                        sectionNumber={'03.'}
                        text={_.get(
                            this.state,
                            'response.acf.ourPartners.title',
                            ''
                        )}
                        elements={_.get(
                            this.state,
                            'response.acf.ourPartners.logos',
                            []
                        )}
                    />
                    <SectionContact version={1} pageType="send-form-home" />
                </div>
            );
        } else {
            return <Redirect to="/error" />;
        }
    }
}
